<template>
  <Component :is="tag" v-if="rendered" v-show="visible">
    <slot />
  </Component>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  visible: boolean
  tag?: string
}

const { visible, tag = 'div' } = defineProps<Props>()

defineSlots<{
  default?(): any
}>()

const rendered = ref(visible)

watch(
  () => visible,
  () => {
    if (visible) {
      rendered.value = true
    }
  },
)
</script>
